let promoOnly = false;
let timeout = false;
let delay = 250;

window.addEventListener("load", (event) => {
    setFeaturedProductsHeight();
    alignFiltersSectionAndLayoutControls();
    initializeSwipers();
    positionPopover();

    /* Promo filter */
    const products = document.getElementsByClassName("product-with-metadata");
    const promoFilterSwitch = document.getElementById("filter-promo");
    if (products && promoFilterSwitch) {
        promoFilterSwitch.addEventListener("change", (evt) => customFilterElementSelected(evt, 'promo'));
        promoFilterSwitch.addEventListener("input", (evt) => evt.stopPropagation(), true);
    }

    /* User selected layout */
    document.getElementById("featured-control-disable")?.addEventListener("click", hideFeaturedProducts);
    document.getElementById("featured-control-enable")?.addEventListener("click", showFeaturedProducts);

    /* Price range slider */
    const slider = document.getElementById('price-range-slider');
    if (slider) {
        initializeDoubleSlider(slider);
        document.querySelectorAll(".facets__price > .field > .field__input").forEach((priceInput) => {
            priceInput.addEventListener("change", priceInputUpdated);
        });
    }
});

window.addEventListener("resize", function () {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
        setFeaturedProductsHeight();
        positionPopover();
    }, delay);
});

function applyCustomFilter() {
    const products = document.querySelectorAll("#template--collection > li");
    for (const product of products) {
        const isPromoMatching = !promoOnly || product.dataset.promo != undefined;
        let filteredItemsCount = document.getElementById("nbItemsFiltered");

        if (!isPromoMatching) {
            if (!product.classList.contains("d-none")) {
                if (filteredItemsCount) {
                    filteredItemsCount.innerText--;
                }
                product.classList.add("d-none");
            }
        }
        else {
            if (product.classList.contains("d-none")) {
                if (filteredItemsCount) {
                    filteredItemsCount.innerText++;
                }
                product.classList.remove("d-none");
            }
        }
    }
}

function customFilterElementSelected(evt, elementType) {
    switch (elementType) {
        case 'promo':
            promoOnly = evt.currentTarget.checked;
            applyCustomFilter(); //Apply filter on state change without the need of a button
            break;
    }
}

function initializeDoubleSlider(slider) {
    const priceMin = Number(slider.dataset.min);
    const priceMax = Number(slider.dataset.max);
    noUiSlider.create(slider, {
        start: [priceMin, priceMax],
        step: 10,
        padding: [priceMin, 0],
        range: {
            'min': [0],
            'max': [priceMax]
        },
        connect: [false, true, false],
        format: {
            to: (value) => Math.round(value),
            from: (value) => Number(value)
        }
    });

    const URLParams = (new URL(document.location)).searchParams;
    const priceMaxParam = "filter.v.price.gte";
    const priceMinParam = "filter.v.price.lte";
    if (URLParams.has(priceMaxParam)) {
        slider.noUiSlider.setHandle(1, URLParams.get(priceMaxParam), false, true);
    }
    if (URLParams.has(priceMinParam)) {
        slider.noUiSlider.setHandle(1, URLParams.get(priceMinParam), false, true);
    }

    slider.noUiSlider.on("change", handleSliderChange);
    slider.noUiSlider.on("update", handleSliderUpdate);
}

function handleSliderChange(values, handle) {
    const pricesInput = document.querySelectorAll(".facets__price > .field > .field__input");
    pricesInput[handle].value = values[handle];
    pricesInput[handle].dispatchEvent(new Event("change", { bubbles: true }));
    pricesInput[handle].dispatchEvent(new Event("input", { bubbles: true }));
}

function handleSliderUpdate(values, handle) {
    const pricesInput = document.querySelectorAll(".facets__price > .field > .field__input");
    pricesInput[handle].value = values[handle];
}

function priceInputUpdated(evt) {
    const slider = document.getElementById('price-range-slider');
    if (evt.target.id.includes("max")) {
        slider.noUiSlider.setHandle(1, evt.target.value, true, true);
    }
    else if (evt.target.id.includes("min")) {
        slider.noUiSlider.setHandle(0, evt.target.value, true, true);
    }
}

function showFeaturedProducts() {
    document.getElementById("featured-control-disable").classList.remove("featured-control-active");
    document.getElementById("featured-control-enable").classList.add("featured-control-active");
    document.getElementById("template--collection").classList.remove("hide-big-featured-products");
    const normalFeaturedProducts = document.getElementsByClassName("is-featured-product-visible");
    for (const product of normalFeaturedProducts) {
        product.classList.remove("is-featured-product-visible");
        product.classList.add("is-featured-product-hidden");
    }
}

function hideFeaturedProducts() {
    document.getElementById("featured-control-enable").classList.remove("featured-control-active");
    document.getElementById("featured-control-disable").classList.add("featured-control-active");
    document.getElementById("template--collection").classList.add("hide-big-featured-products");
    const normalFeaturedProducts = document.getElementsByClassName("is-featured-product-hidden");
    for (const product of normalFeaturedProducts) {
        product.classList.remove("is-featured-product-hidden");
        product.classList.add("is-featured-product-visible");
    }
}

function setFeaturedProductsHeight() {
    if (document.getElementById("template--collection")) {
        const rowGap = getComputedStyle(document.getElementById("template--collection")).rowGap;
        const cardHeight = getComputedStyle(document.querySelector("article.indiv-product")).height;
        const imgHeight = getComputedStyle(document.querySelector("article.indiv-product img")).height;

        // We want the featured image to have the height of 1 card height + 1 gap + 1 image height

        document.getElementById("CollectionProductGrid").style.setProperty("--featured-products-height", `calc(${rowGap} + ${cardHeight} + ${imgHeight})`);
    }
}

function paginationCompleteCallback() {
    applyCustomFilter();
    initializeSwipers();
    const featuredProducts = document.getElementsByClassName("featured-product");
    const products = document.getElementsByClassName("product-with-metadata");

    for (const featuredProduct of featuredProducts) {
        let minToShow = Number(featuredProduct.dataset.minToShow);
        if (products.length >= minToShow) {
            featuredProduct.classList.remove("d-md-none");
        }
    }
}

function initializeSwipers() {
    const swipers = document.getElementsByClassName("product-grid-swiper");
    for (const swiperElement of swipers) {
        if (!swiperElement.swiper) {
            let prevButton = swiperElement.getElementsByClassName("swiper-button-prev")[0];
            let nextButton = swiperElement.getElementsByClassName("swiper-button-next")[0];
            new Swiper(swiperElement, {
                breakpoints: {
                    0: {
                        allowTouchMove: true
                    },
                    768: {
                        allowTouchMove: false
                    }
                },
                initialSlide: swiperElement.dataset.showSecondImage != null ? 1 : 0,
                lazyPreloadPrevNext: 1,
                loop: true,
                slidesPerView: 1,
                spaceBetween: 1,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                }
            });
        }
    }
}

function alignFiltersSectionAndLayoutControls() {
    const filtersSection = document.getElementsByClassName("apo-filter-and-sort")[0];
    const gridSection = document.getElementsByClassName("collection-grid-wrapper")[0];
    const layoutControls = document.getElementById("collection-grid-layout-controls");

    /* We check if we have layout controls and the 2 elements are siblings */
    if (layoutControls && filtersSection.nextElementSibling === gridSection) {
        /* Set the filters z-index to a higher value so it can be usable */
        filtersSection.style.zIndex = 2;

        /* Get filters margin-top setting, apply to collection grid */
        const filtersSectionMarginTopClass = Array.from(filtersSection.firstElementChild.classList.values()).find(c => c.startsWith("mt"));
        const gridSectionMarginTopClass = Array.from(gridSection.firstElementChild.classList.values()).find(c => c.startsWith("mt"));
        if (gridSectionMarginTopClass) {
            gridSection.firstElementChild.classList.remove(gridSectionMarginTopClass);
        }
        gridSection.firstElementChild.classList.add(filtersSectionMarginTopClass);

        /* Get filters section height, set as negative margin for the collection grid */
        const filtersSectionHeight = filtersSection.getBoundingClientRect().height;
        gridSection.style.marginTop = -1 * filtersSectionHeight + "px";

        /* Get filter button padding Y, apply to layout controls */
        const filterButton = document.querySelector("button[popovertarget='filters-popover']");
        layoutControls.style.paddingTop = getComputedStyle(filterButton).paddingTop;
        layoutControls.style.paddingBottom = getComputedStyle(filterButton).paddingBottom;

        /* Get layout controls position, remove amount from filters width */
        const layoutControlsPosition = layoutControls.firstElementChild.firstElementChild.getBoundingClientRect().x;
        filtersSection.style.width = `calc(100% - ${window.innerWidth - layoutControlsPosition}px)`;
    }
}

function positionPopover() {
    const buttonOffset = document.querySelector("button[popovertarget='filters-popover']").getBoundingClientRect().y;
    document.getElementById("filters-popover").style.top = (Math.ceil(buttonOffset) + 45) + "px";
}